import _get from 'lodash/get';
import actionType from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_CURRENT_GROUP_ELEMENT: {
            return {
                ...state,
                currentGroupElement: action.payload,
            };
        }
        case actionType.GET_CURRENT_SOURCE_ELEMENT: {
            return {
                ...state,
                currentSourceElement: action.payload,
            };
        }
        case actionType.GET_CURRENT_GROUP_SOURCE_FIELD_MAP: {
            return {
                ...state,
                currentGroupSourceFieldMap: action.payload,
            };
        }
        case actionType.GET_CURRENT_DATA_IMPORT_ELEMENT: {
            return {
                ...state,
                currentDataImportElement: action.payload,
            };
        }
        case actionType.SET_IMPORT_COMPARISON_RESULT: {
            return {
                ...state,
                importComparisonResult: action.payload,
            };
        }
        case actionType.SET_IMPORT_SETUP_MODAL_DATA: {
            return {
                ...state,
                importSetupModalData: action.payload,
            };
        }
        case actionType.CLEAR_IMPORT_COMPARISON_RESULT: {
            return {
                ...state,
                importComparisonResult: initialState.importComparisonResult,
            };
        }
        default:
            return state;
    }
};
